var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8197 63H57.6597V52.8H54.3797V51.26H55.0197C56.4997 51.26 57.3397 50.88 57.9197 49.6H59.8197V63Z",
    fill: "#09041C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56.5,
    stroke: "#DDDFE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9997 57C92.9997 36.5655 76.4342 20 55.9997 20",
    stroke: "#FCE80F",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9997 94C76.4342 94 92.9997 77.4345 92.9997 57",
    stroke: "#FF6633",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 57C18.9997 77.4345 35.5652 94 55.9997 94",
    stroke: "#28DDCF",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9997 20C35.5652 20 18.9997 36.5655 18.9997 57",
    stroke: "#764AFF",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/number-1.4d035bad8d4478c7642cdb520c2efa9a.svg";
export { ForwardRef as ReactComponent };